import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

/**
 * The bar a fullscreen dialog ends on: ruled off from the scrolling body, in
 * the paper's own colour, and always in reach.
 *
 * Only the bar - what stands on it is the dialog's business. The record
 * editors put Abbrechen and Speichern there ({@link FormDialogFooter}), the
 * sync dialog its three actions; both look the same because they share this.
 */
export default function DialogFooterBar({
    children,
    sx
}: {
    children: ReactNode;
    sx?: SxProps<Theme>;
}) {
    return (
        <Box
            sx={[
                {
                    borderTop: 1,
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    px: { xs: 2, sm: 3 },
                    py: 1.5,
                    display: 'flex',
                    /**
                     * Never squeezed by an overlong body: as a flex item of the
                     * dialog's column the bar would otherwise give up height to
                     * a body taller than the dialog, and its buttons with it.
                     */
                    flexShrink: 0,
                    justifyContent: 'flex-end',
                    gap: 1
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
        >
            {children}
        </Box>
    );
}
